module.exports = __webpack_public_path__ + "static/korede-6c44493e520c10bd1f7879288736efd4.png";